import { render, staticRenderFns } from "./CategoryWidget.vue?vue&type=template&id=81167372&lang=pug&"
import script from "./CategoryWidget.vue?vue&type=script&lang=js&"
export * from "./CategoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports